import axios from "axios";
import { TRANSLATE_API_URL } from "@/config";
import { handleError } from "./handleError";

export const apiClient = axios.create({
  baseURL: TRANSLATE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Sends a POST request to the translation API with retry logic.
 * @param url - API endpoint URL
 * @param body - Request body
 * @param params - Query parameters
 * @param retryCount - Number of retry attempts in case of failure
 * @returns Response data or null on failure
 */
export const sendPostRequest = async <T>(
  url: string,
  body: Record<string, unknown>,
  params: Record<string, string>
): Promise<T | null> => {
  try {
    const response = await apiClient.post<T>(url, body, { params });
    if (response.status === 200) return response.data;
  } catch (error: any) {
    if (error.response) {
      handleError(error.response);
    } else {
      throw new Error("An unknown error occurred"); 
    }
  }
  return null;
};
